import React, {Component} from 'react';
import {connect} from 'react-redux';
import ErrorBoundary from './ErrorBoundary';
import Login from '../views/authentication/login';
import Fulllayout from '../layouts/fulllayout';
import {checkAutorization} from '../actions/authActions';
import {changeLanguage} from '../actions/commonsActions';
import {fetchCompanies} from "../actions/companyActions";
import {languageModel} from '../helpers/LanguageModel';
import moment from "moment/moment";

export class App extends Component {

	state = {
		lang: 'en',
		supportedLangs: ['en', 'ru'],
		loading: false
	};

	componentDidMount() {
		console.log('app mount');
		let language = this.state.lang;
		if (localStorage.getItem('userLang')) {
			language = localStorage.getItem('userLang')
		} else {
			language = ((navigator.languages && navigator.languages[0]) ||
				navigator.language || navigator.userLanguage).slice(0, 2);
		}
		//await this.props.fetchCompanies();
		this.setState({
			lang: this.state.supportedLangs.includes(language) ? language : 'en',
			loading: true
		}, async () => {
			await this.props.changeLanguage(this.state.lang);
			await this.props.checkAutorization();
			await languageModel.initPromise.then(() => {
				languageModel.getLocalStorageLanguage().toLowerCase();
				const body = document.getElementsByTagName('body')[0];
				body.className = [languageModel.currentLanguageDirection().toUpperCase(), 'ru'].join(',');
			}).catch(({ message }) => {
				console.error(message)
			});
			this.setState({loading: false})
		});
		this.setLocalesWeekStartToMonday();
	}

	setLocalesWeekStartToMonday = () => {
		this.state.supportedLangs.forEach(lang => {
			moment.updateLocale(lang, {
				week: { dow: 1 }
			});
		});
	}

	render() {
		console.log('app render');
		const {
			hasErrored,
			isLoading,
			isAuth
		} = this.props;
		const {lang, loading} = this.state;
		if (hasErrored) {
			return (
				<div className='app__inner'>
					<ErrorBoundary>
						<div className='main-error'>
							Sorry! There was an error loading the items
						</div>
					</ErrorBoundary>
				</div>
			);
		}

		if (loading) {
			return (
				<div className='app__inner'>
					<ErrorBoundary>
						<div>Loading...</div>
					</ErrorBoundary>
				</div>
			);
		}
		return (
			<div className='app__inner'>
				<ErrorBoundary>
					{/*isAuth ? ( */}
					{
						isAuth ? (
							<Fulllayout {...this.props}/>
						) : (
							<Login lang={lang}/>
						)
					}
				</ErrorBoundary>
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		checkAutorization: () => dispatch(checkAutorization()),
		changeLanguage: lang => dispatch(changeLanguage(lang)),
		fetchCompanies: query => dispatch(fetchCompanies(query)),
	};
};

const mapStateToProps = state => ({
	hasErrored: false,
	//isLoading: state.companiesReducer.loading,
	isAuth: state.isAuth,
	companies: state.companiesReducer.companies,
});

export default connect(mapStateToProps, mapDispatchToProps)(App)
//https://github.com/supasate/connected-react-router/blob/master/FAQ.md#how-to-migrate-from-v4-to-v5



// WEBPACK FOOTER //
// ./src/components/App.js